import { RedIcon } from "@/components/styled";
import { IDocument } from "@/interfaces";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCircleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { Badge, Space, Spin } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

interface IProps {
  documents: IDocument[];
  requiresDocumentsAlert: boolean;
  isLoading: boolean;
}

const DEFAULT_DOCUMENT_COUNT = 0;

export const DocumentTabHeader = ({
  documents,
  requiresDocumentsAlert,
  isLoading,
}: IProps) => {
  const intl = useIntl();

  const [documentsCount, setDocumentsCount] = useState<number | undefined>();

  useEffect(() => {
    if (documents === undefined) return;

    setDocumentsCount(documents.length || DEFAULT_DOCUMENT_COUNT);
  }, [documents]);

  return (
    <Space>
      {intl.formatMessage({ id: "milestoneDetails.documents" })}
      {isLoading || documentsCount === undefined ? (
        <Spin size="small" />
      ) : (
        <>
          {requiresDocumentsAlert ? (
            <RedIcon icon={faCircleExclamation as IconProp} />
          ) : (
            <Badge count={documentsCount} showZero />
          )}
        </>
      )}
    </Space>
  );
};
